/** Variación relativa en %. */
export function relativeChangePct(current: number, previous: number): number | null {
  if (previous === 0) {
    return null;
  }
  return ((current - previous) / previous) * 100;
}

export function formatSigned(locale: string, value: number, maxFractionDigits = 1): string {
  const abs = Math.abs(value).toLocaleString(locale, { maximumFractionDigits: maxFractionDigits });
  if (value > 0) {
    return `+${abs}`;
  }
  if (value < 0) {
    return `-${abs}`;
  }
  return abs;
}

export function formatMoneyCompact(locale: string, value: number): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'ARS',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value);
}

export type AttentionSeverity = 'critical' | 'warning' | 'info';

/** Umbrales simples de severidad para ingresos (MoM %). */
export function revenueDropSeverity(deltaPct: number | null): AttentionSeverity | null {
  if (deltaPct === null || deltaPct >= -10) {
    return null;
  }
  if (deltaPct <= -25) {
    return 'critical';
  }
  return 'warning';
}

/** Umbrales simples para ausentismo (pp vs mes anterior o nivel absoluto). */
export function absenteeismSeverity(current: number, deltaPp: number): AttentionSeverity | null {
  if (current >= 18 || deltaPp >= 5) {
    return 'critical';
  }
  if (current >= 12 || deltaPp >= 3) {
    return 'warning';
  }
  return null;
}
